<template>
  <div id="app" style="height: 100vh; overflow:scroll;" :class="nombreClase">
    <div class="text-sm text-gray-400 justify-center">{{ institucion }} [{{ version }}]</div>
    <button v-if="updateExists" @click="refreshApp" class="bg-paleta-1 text-yellow-200 font-bold mx-4 p-2 rounded-md">
      Hay una nueva versión disponible! Click aquí para actualizar
    </button>
    <router-view />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      version: process.env.VUE_APP_VERSION,
      refreshing: false,
      registration: null,
      updateExists: false,
      institucion: process.env.VUE_APP_INSTITUCION,
      nombreClase: "bg-gradient-to-br " + process.env.VUE_APP_COLOR_FROM + " " + process.env.VUE_APP_COLOR_TO
    };
  },
  created: function() {
    if (this.$hub) {
      this.$hub.$on("Deshabilitar", this.deshabilitar);
      this.$hub.$on("RecargaConfirmada", this.recargaConfirmada);
      this.$hub.$on("PruebaNotificacion", this.pruebaNotificacion);
    }
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
  methods: {
    showRefreshUI(e) {
      this.registration = e.detail;
      this.updateExists = true;
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    recargaConfirmada: function(saldo) {
      this.$store.dispatch("recargaConfirmada", { saldo });
    },
    pruebaNotificacion: function(/*payload*/) {
      //console.log("Prueba notificacion: " + payload);
    },
    deshabilitar: function() {
      //this.$router.push("/");
    },
    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage("skipWaiting");
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
